module.exports = __webpack_public_path__ + "static/media/Deloitte.98f805ab.svg";